module.exports = __webpack_public_path__ + "static/media/upload.5691ad5f.svg";